import React, { useState } from "react";
import { useLocation, Link as RouterLink, matchPath } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import PropTypes from "prop-types";
import {
  Box,
  Drawer,
  List,
  ListSubheader,
  makeStyles,
  IconButton,
  Link,
} from "@material-ui/core";
import { Menu } from "react-feather";
import { Info as InfoIcon } from "react-feather";
import NavItem from "src/layouts/DashboardLayout/NavBar/NavItem";
/* eslint-disable no-use-before-define */

function renderNavItems({ items, pathname, depth = 0 }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, pathname, depth }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({ acc, pathname, item, depth }) {
  const key = item.title + depth;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false,
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items,
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        info={item.info}
        key={key}
        title={item.title}
      />
    );
  }

  return acc;
}

const useStyles = makeStyles((theme) => ({
  mobileDrawer: {
    width: 256,
  },
  desktopDrawer: {
    width: 256,
    top: 0,
    height: "100%",
    background: theme.palette.background.dark,
  },
  avatar: {
    cursor: "pointer",
    width: 50,
    height: 50,
  },
  avatarBig: {
    cursor: "pointer",
    width: 150,
    height: 150,
  },
  socialIcon: {
    cursor: "pointer",
    marginRight: 5,
  },
}));

const NavBar = ({ sections }) => {
  const classes = useStyles();
  const [rightBar, setRightBar] = useState(false);
  const location = useLocation();
  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Box>
          {sections.map((section, i) => (
            <List
              key={`menu${i}`}
              subheader={
                <ListSubheader disableGutters disableSticky>
                  {section.subheader}
                </ListSubheader>
              }
            >
              {renderNavItems({
                items: section.items,
                pathname: location.pathname,
              })}
            </List>
          ))}
          <Link
            style={{
              display: "flex",
              alignItems: "center",
              color: "#969ba1",
            }}
            underline="none"
            variant="body2"
            href="https://research.admantium.finance/"
            target="_blank"
            color={"inherit"}
          >
            <InfoIcon
              size={20}
              style={{ color: "#969ba1", paddingLeft: 25, paddingRight: 15 }}
            />{" "}
            Research
          </Link>
          <Link
            style={{
              display: "flex",
              alignItems: "center",
              color: "#969ba1",
              marginTop: 20,
            }}
            underline="none"
            variant="body2"
            component={RouterLink}
            color={"inherit"}
            to="/dashboard"
          >
            <InfoIcon
              size={20}
              style={{ color: "#969ba1", paddingLeft: 25, paddingRight: 15 }}
            />{" "}
            Enter Application
          </Link>
        </Box>
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      <IconButton
        onClick={() => {
          setRightBar(!rightBar);
        }}
      >
        <Menu color="#ffffff" />
      </IconButton>

      <Drawer
        anchor="right"
        classes={{ paper: classes.desktopDrawer }}
        open={rightBar}
        onClose={() => {
          setRightBar(false);
        }}
      >
        {content}
      </Drawer>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default NavBar;
